import { FC } from 'react';
import { useTranslation } from '../../hooks/use-translation';

interface DownloadInProgressLabelProps {
  // Electron downloads go through the shell's downloadApp (an installer file
  // download) rather than installApp, so the in-progress verb differs
  // ("Downloading..." vs "Installing...").
  isElectron?: boolean;
}

// -----------------------------------------------------------------------------
// The spinner + in-progress verb shown on a download button while the Overwolf
// client is installing/downloading an app (replaces the button's normal
// content). Rendered by both the main and the multi-download buttons; the
// caller decides when to show it (only inside the client — the web keeps the
// striped `.is-downloading` background instead).
const DownloadInProgressLabel: FC<DownloadInProgressLabelProps> = ({
  isElectron = false,
}) => {
  const { t } = useTranslation();

  return (
    <span className="dl-btn-installing">
      <span className="dl-btn-spinner" aria-hidden="true" />
      {isElectron ? t('downloading') : t('installing')}
    </span>
  );
};

export default DownloadInProgressLabel;
